import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import FinanceRequirements from "@/pages/checkout/pre-checkout/how-to-finance/FinanceRequirements";
import FinanceSteps from "@/pages/checkout/pre-checkout/how-to-finance/FinanceSteps";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { trackEvents } from "@/common/events/events";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
var HowToFinanceContent = function HowToFinanceContent(_ref) {
  var _useCheckoutOrder, _useCheckoutOrder$sta;
  var isNew = _ref.isNew,
    postId = _ref.postId,
    _ref$showFinanceSteps = _ref.showFinanceSteps,
    showFinanceSteps = _ref$showFinanceSteps === void 0 ? false : _ref$showFinanceSteps,
    financeSteps = _ref.financeSteps,
    g4Data = _ref.g4Data;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var checkoutOrder = (_useCheckoutOrder = useCheckoutOrder()) === null || _useCheckoutOrder === void 0 ? void 0 : (_useCheckoutOrder$sta = _useCheckoutOrder.state) === null || _useCheckoutOrder$sta === void 0 ? void 0 : _useCheckoutOrder$sta.checkoutOrder;
  var handleNavigation = function handleNavigation() {
    trackEvents("continue_finance_clicked", {
      post_id: postId,
      car_make: g4Data === null || g4Data === void 0 ? void 0 : g4Data.post_make,
      car_model: g4Data === null || g4Data === void 0 ? void 0 : g4Data.post_model,
      car_year: g4Data === null || g4Data === void 0 ? void 0 : g4Data.post_year
    });
    trackEvents("checkout", _objectSpread(_objectSpread({}, g4Data), {}, {
      booking_type: "finance",
      post_trim: g4Data === null || g4Data === void 0 ? void 0 : g4Data.post_ext,
      from_finance_calculator: false,
      inventory_type_string: g4Data === null || g4Data === void 0 ? void 0 : g4Data.inventory_type_string
    }));
    if (checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.is_eligible_for_arib) {
      navigateTo("/finance-apply-arib?post_id=".concat(postId));
    } else {
      navigateTo("/finance-apply-free/".concat(postId, "?financestep=1"));
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "sm-only:overflow-y-scroll max-h-full md:max-h-[unset] md:overflow-y-hidden"
  }, /*#__PURE__*/React.createElement(FinanceRequirements, {
    isNew: isNew
  }), showFinanceSteps && /*#__PURE__*/React.createElement(FinanceSteps, {
    financeSteps: financeSteps
  }), showFinanceSteps && /*#__PURE__*/React.createElement("div", {
    className: "p-4 md:max-w-[360px] mx-auto"
  }, /*#__PURE__*/React.createElement("button", {
    className: "cursor-pointer w-full p-4 bg-success text-white border-none outline-none text-lg font-bold leading-normal rounded",
    onClick: handleNavigation
  }, tShort("pre-checkout/continue_cta", {
    ns: "web_checkout_finance"
  })))));
};
export default HowToFinanceContent;